// App.jsx
import React from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./pages/Login/AuthContext"; // Importa el contexto de autenticación
import ProtectedRoute from "./pages/Login/ProtectedRoute"; // Importa el componente de ruta protegida
import Login from "./pages/Login/Login"; // Asegúrate de crear esta página
import Casas from "./pages/casa/Casa";
import Terrenos from "./pages/terrenos/Terrenos";
import Campos from "./pages/campos/Campo";
import Quintas from "./pages/quintas/Quintas";
import Forestaciones from "./pages/Forestaciones/Forestaciones";
import Galpones from "./pages/galpones/Galpones";
import Departamentos from "./pages/deptos/Depto";
import Home from "./pages/Home/Home";
import Inmueble from "./pages/Mostrar/Inmueble";
import Locales from "./pages/locales/Locales";
import Mostrar from "./hooks/Mostrar";
import Tabla from "./hooks/Tabla";
import Root from "./hooks/Root";
import EditarTabla from "./hooks/EditarTabla";
import Otras from "./pages/otro/Otros";
import Crear from "./Consultas/Crear";

function App() {
	return (
		<AuthProvider> {/* Envuelve toda la aplicación con el proveedor de autenticación */}
			<Router>
				<Routes>
					{/* Rutas públicas (sin autenticación requerida) */}
					<Route path="/" element={<Home />} />
					<Route path="/casas" element={<Casas />} />
					<Route path="/terrenos" element={<Terrenos />} />
					<Route path="/campos" element={<Campos />} />
					<Route path="/quintas" element={<Quintas />} />
					<Route path="/forestaciones" element={<Forestaciones />} />
					<Route path="/galpones" element={<Galpones />} />
					<Route path="/departamentos" element={<Departamentos />} />
					<Route path="/locales" element={<Locales />} />
					<Route path="/otraspropiedades" element={<Otras />} />
					{/* Esta ruta no requiere autenticación */}
					<Route path="/inmueble/:id/:slug" element={<Inmueble />} />

					{/* Rutas de autenticación */}
					<Route path="/login" element={<Login />} />

					{/* Rutas privadas (requieren autenticación) */}
					<Route element={<ProtectedRoute />}>
						<Route path="/perca" element={<Root />} />
						<Route path="/crear" element={<Crear />} />
						<Route path="/tabla" element={<Tabla />} />
						<Route path="/editar/:id" element={<EditarTabla />} />
						<Route path="/mostrar/:id" element={<Mostrar />} />
					</Route>

					{/* Ruta de fallback para rutas no definidas (redirige a login) */}
					<Route path="*" element={<Navigate to="/login" />} />
				</Routes>
			</Router>
		</AuthProvider>
	);
}

export default App;
